import React from 'react';

import { getCurrentUserId } from 'common-src/features/auth';
import { singleModelSelector } from 'common-src/utils/selectorUtils';

import useCustomSelector from 'src/hooks/useCustomSelector';

import { DATE_TODAY } from '../../constants';
import styles from './CareOrchestrationHeader.module.scss';

const CareOrchestrationHeader = ({
  view,
  readinessStats,
  stats,
  onChangeView,
  onClearSelections,
}) => {
  const safeReadiness = readinessStats ?? { red: 0 };
  const safeStats = stats ?? { total: 0 };
  const currentUser = useCustomSelector((state) =>
    singleModelSelector(state, 'Client', getCurrentUserId(state)),
  );
  const userInitials = `${currentUser?.firstName?.charAt(0) || ''}${
    currentUser?.lastName?.charAt(0) || ''
  }`;

  const tabs = [
    {
      key: 'readiness',
      label: 'Readiness',
      badge: safeReadiness.red > 0 ? `${safeReadiness.red} not ready` : null,
    },
    { key: 'tasks', label: 'Tasks', count: safeStats.total },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <div className={styles.logo}>
            <span className={styles.logoText}>M</span>
          </div>
          <div>
            <div className={styles.title}>Care Orchestration</div>
            <div className={styles.subtitle}>Post-99205 → Phase 2 Readiness</div>
          </div>
        </div>
        <div className={styles.tabs}>
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => {
                onChangeView(item.key);
                onClearSelections();
              }}
              className={`${styles.tabButton} ${view === item.key ? styles.activeTab : ''}`}
            >
              {item.label}
              {item.count != null && <span className={styles.tabCount}>{item.count}</span>}
              {item.badge && <span className={styles.tabBadge}>{item.badge}</span>}
            </button>
          ))}
        </div>
        <div className={styles.meta}>
          <span className={styles.today}>{DATE_TODAY}</span>
          <div className={styles.avatar}>{userInitials || '--'}</div>
        </div>
      </div>
    </div>
  );
};

export default CareOrchestrationHeader;
